import { render, staticRenderFns } from "./houseKeepingService.vue?vue&type=template&id=9a0fc932"
import script from "./houseKeepingService.vue?vue&type=script&lang=js"
export * from "./houseKeepingService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports